import { GraphQLResult } from "@aws-amplify/api";
import { PFXCredentialsResponse, CheckCredentialsQuery } from "../Interfaces";
import _ from "lodash";
export const getCredentialsQuery = companyId => `
  query q {
    checkCredentials(companyId:"${companyId}"){
      AC{
        sendEmail
      }
      BT {
        hasBT
        urls
      }
      EC {
        hasEC
        ECClient
        ECPublicKey
      }
      MP {
        hasMP
        variableCommission
      }
      MU {
        hasMU
        extraCost
      }
      RB {
        hasRB
        clientAppCode
        clientAppKey
        pse
        card
      }
      PT {
        hasPT
        clientAppCode
        clientAppKey
      }
      WP {
        hasWP
        publicKey
      }
      PI {
        hasPI
      }
      PZ {
        hasPZ
        publicKey
        user
        pse
        card
      }
      ST{
        hasST
        publishableKey
      }
      RP{
        hasRP
        clientId
      }
      FB{
        hasFB
        pixelId
      }
      GA{
        hasGA
        googleAnalyticsId
        crossDomainGA
      }
      GTM{
        hasGTM
        googleTagManagerId
      }
    }
  }
`;

export function getCredentials(checkCredentialsResponse: GraphQLResult<CheckCredentialsQuery>): PFXCredentialsResponse {
  let checkCredentials = checkCredentialsResponse.data?.checkCredentials;
  let result = _.pickBy(checkCredentials, _.identity) as PFXCredentialsResponse;
  for (const key in result) {
    result[key] = _.pickBy(result[key], _.identity);
  }
  return result as PFXCredentialsResponse;
}
